import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'

export const GenericDataQualityScore: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="mb-5">
      <div className="piece-content-inputs">
        <InputItem
          name="Overall DQS"
          description=""
          type="input"
          formik={formik}
          showAsterisk
          onChange={formik.handleChange}
          defaultValue={formik.values.dqs.overall || ''}
          formikName="dqs.overall"
        />
        <InputItem
          name="Time DQS"
          description=""
          type="input"
          formik={formik}
          showAsterisk
          onChange={formik.handleChange}
          defaultValue={formik.values.dqs.time || ''}
          formikName="dqs.time"
        />
        <InputItem
          name="Geography DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.geography"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.geography}
        />
        <InputItem
          name="Reliability DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.reliability"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.reliability}
        />
        <InputItem
          name="Completeness DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.completeness"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.completeness}
        />
        <InputItem
          name="Tech System DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.techSystem"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.techSystem}
        />
        <InputItem
          name="Tech Crop DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.techCrop"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.techCrop}
        />
        <InputItem
          name="Site Energy DQS"
          description=""
          type="input"
          onChange={formik.handleChange}
          formikName="dqs.siteEnergy"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.dqs.siteEnergy}
        />
      </div>
    </div>
  )
}

export default GenericDataQualityScore
